import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor() { }
  private emitChangeSource = new Subject<any>();

    changeEmitted$ = this.emitChangeSource.asObservable(); //Create obserable for changed emited

    emitChange(Head:any) {                       //Create custom event to pass data to app component
        this.emitChangeSource.next(Head);
    }
}
